import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";


export const UpdateClassBookingService=async(data,id)=>{
    try {
        const result = await put(`api/class_booking/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreateClassBookingService=async(data,id)=>{
    try {
        const result = await post(`api/class_booking/create_manual`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const RegenerateGoogleMeetBookingService=async(id)=>{
    try {
        const result = await post(`api/class_booking/regenerate_google_meet_link/${id}`, {});
        return result;
    } catch (err) {
        return err.response;
    }
}

export const RegenerateGoogleMeetBatchBookingService=async(id)=>{
    try {
        const result = await post(`api/personal_training_subscription_teacher_batches/regenerate_google_meet_link/${id}`, {});
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClassBookingService=async(page,text,status,teacher,from_date,to_date)=>{
    try {
        const result = await get(`api/class_booking/get?page=${page}&search=${text}&status=${status}&teacher=${teacher}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const TeacherJoinLinkClassBookingService=async(id)=>{
    try {
        const result = await put(`api/class_booking/generate_teacher_link/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClassBookingBasedTeacherService=async(data)=>{
    try {
        const result = await get(`api/class_booking/get_booking_based_teacher?page=${data?.page}&search=${data?.search}&status=${data?.status}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetPersonalTrainingSubscriptionTeacherService=async(data)=>{
    try {
        const result = await get(`api/personal_training_subscription_teacher_batches/get?page=${data?.page}&teacher=${data?.teacher}&mode=${data?.mode}&batch=${data?.batch}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeletePersonalTrainingSubscriptionTeacherService=async(id)=>{
    try {
        const result = await deleteRequest(`api/personal_training_subscription_teacher_batches/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetPersonalTrainingSubscriptionTeacherTimeTableService=async(data)=>{
    try {
        const result = await get(`api/personal_training_subscription_teacher_batches/get_time_table_based_batch?page=${data?.page}&from_date=${data?.from_date}&to_date=${data?.to_date}&personal_training_subscription_teacher_batch=${data?.personal_training_subscription_teacher_batch}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetPersonalTrainingSubscriptionStudentSummaryService=async(id,date)=>{
    try {
        const result = await get(`api/personal_training_subscription_teacher_batches/get_student_day_wise_report/${id}?date=${date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdatePersonalTrainingSubscriptionStudentSummaryService=async(id,data)=>{
    try {
        const result = await put(`api/personal_training_subscription_teacher_batches/update_student_day_wise_report/${id}`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GenerateStudentWeeklyReportService=async(id,data)=>{
    try {
        const result = await get(`api/personal_training_subscription_teacher_batches/generate_weekly_report_pdf`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GenerateCustomReportMissingService=async(id)=>{
    try {
        const result = await get(`api/personal_training_subscription_teacher_batches/generate_custom_report_pdf_missing/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GenerateCustomStudentReportService=async(data)=>{
    try {
        const result = await post(`api/personal_training_subscription_teacher_batches/generate_custom_report_pdf`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateBulkPersonalTrainingSubscriptionStudentSummaryService=async(id,data)=>{
    try {
        const result = await put(`api/personal_training_subscription_teacher_batches/update_all_student_day_wise_report_for_a_batch/${id}`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeletePersonalTrainingSubscriptionStudentSummaryService=async(id)=>{
    try {
        const result = await deleteRequest(`api/personal_training_subscription_teacher_batches/delete_student_day_wise_report/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreatePersonalTrainingSubscriptionTeacherTimeTableService=async(data)=>{
    try {
        const result = await post(`api/personal_training_subscription_teacher_batches/create_time_table_entry`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdatePersonalTrainingSubscriptionTeacherTimeTableService=async(data,id)=>{
    try {
        const result = await put(`api/personal_training_subscription_teacher_batches/update_time_table_entry/${id}`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeletePersonalTrainingSubscriptionTeacherTimeTableService=async(id)=>{
    try {
        const result = await deleteRequest(`api/personal_training_subscription_teacher_batches/delete_time_table_entry/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetBatchSubscriptionRequestListService=async(data)=>{
    try {
        const result = await get(`api/personal_training_subscription_teacher_batches/get_payment_request?page=${data?.page}&from_date=${data?.from_date}&to_date=${data?.to_date}&text=${data?.search}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdatePersonalTrainingSubscriptionTeacherService=async(data)=>{
    try {
        const result = await put(`api/personal_training_subscription_teacher_batches/update/${data?.id}`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const CreatePersonalTrainingSubscriptionTeacherService=async(data)=>{
    try {
        const result = await post(`api/personal_training_subscription_teacher_batches/create_offline`,data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteClassBookingService=async(id)=>{
    try {
        const result = await deleteRequest(`api/class_booking/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

